export const GLOBAL_STATE = 'StudentInquiries'

export const STUDENT_INQUIRIES = 'STUDENT_INQUIRIES' as const
export const ST_INQUIRIES_PROOF_OF_STUDY_CREATE = 'ST_INQUIRIES_PROOF_OF_STUDY_CREATE' as const
export const ST_INQUIRIES_PROOF_OF_STUDY_LIST = 'ST_INQUIRIES_PROOF_OF_STUDY_LIST' as const
